import { Msg } from "imagica-corekit/dist/base/cutil/Eventbus";

export class CreateFunctionPageBackMsg implements Msg {
  constructor(public edgeId: string = "") {}
  naming: string = "CreateFunctionPageBack";
}
